"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8866],{

/***/ 8866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Quiz; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(1542);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-e01b6482.mjs
var Icon_e01b6482 = __webpack_require__(2007);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-460da2fc.mjs
var Link_460da2fc = __webpack_require__(1607);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Quiz.js









function nr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var U = "top", J = "bottom", Z = "right", Y = "left", Bt = "auto", Ke = [U, J, Z, Y], Le = "start", Ye = "end", rr = "clippingParents", gn = "viewport", We = "popper", ir = "reference", Yt = /* @__PURE__ */ Ke.reduce(function(e, t) {
  return e.concat([t + "-" + Le, t + "-" + Ye]);
}, []), yn = /* @__PURE__ */ [].concat(Ke, [Bt]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Le, t + "-" + Ye]);
}, []), or = "beforeRead", ar = "read", sr = "afterRead", cr = "beforeMain", ur = "main", lr = "afterMain", pr = "beforeWrite", fr = "write", dr = "afterWrite", vr = [or, ar, sr, cr, ur, lr, pr, fr, dr];
function ie(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function X(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Se(e) {
  var t = X(e).Element;
  return e instanceof t || e instanceof Element;
}
function K(e) {
  var t = X(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function qt(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = X(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function hr(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, o = t.elements[n];
    !K(o) || !ie(o) || (Object.assign(o.style, r), Object.keys(i).forEach(function(s) {
      var u = i[s];
      u === !1 ? o.removeAttribute(s) : o.setAttribute(s, u === !0 ? "" : u);
    }));
  });
}
function mr(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], o = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), u = s.reduce(function(c, f) {
        return c[f] = "", c;
      }, {});
      !K(i) || !ie(i) || (Object.assign(i.style, u), Object.keys(o).forEach(function(c) {
        i.removeAttribute(c);
      }));
    });
  };
}
const bn = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: hr,
  effect: mr,
  requires: ["computeStyles"]
};
function re(e) {
  return e.split("-")[0];
}
var xe = Math.max, ht = Math.min, ze = Math.round;
function Dt() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function wn() {
  return !/^((?!chrome|android).)*safari/i.test(Dt());
}
function Pe(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, o = 1;
  t && K(e) && (i = e.offsetWidth > 0 && ze(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && ze(r.height) / e.offsetHeight || 1);
  var s = Se(e) ? X(e) : window, u = s.visualViewport, c = !wn() && n, f = (r.left + (c && u ? u.offsetLeft : 0)) / i, p = (r.top + (c && u ? u.offsetTop : 0)) / o, v = r.width / i, b = r.height / o;
  return {
    width: v,
    height: b,
    top: p,
    right: f + v,
    bottom: p + b,
    left: f,
    x: f,
    y: p
  };
}
function Mt(e) {
  var t = Pe(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function On(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && qt(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function de(e) {
  return X(e).getComputedStyle(e);
}
function gr(e) {
  return ["table", "td", "th"].indexOf(ie(e)) >= 0;
}
function me(e) {
  return ((Se(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function yt(e) {
  return ie(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (qt(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    me(e)
  );
}
function Qt(e) {
  return !K(e) || // https://github.com/popperjs/popper-core/issues/837
  de(e).position === "fixed" ? null : e.offsetParent;
}
function yr(e) {
  var t = /firefox/i.test(Dt()), n = /Trident/i.test(Dt());
  if (n && K(e)) {
    var r = de(e);
    if (r.position === "fixed")
      return null;
  }
  var i = yt(e);
  for (qt(i) && (i = i.host); K(i) && ["html", "body"].indexOf(ie(i)) < 0; ) {
    var o = de(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Je(e) {
  for (var t = X(e), n = Qt(e); n && gr(n) && de(n).position === "static"; )
    n = Qt(n);
  return n && (ie(n) === "html" || ie(n) === "body" && de(n).position === "static") ? t : n || yr(e) || t;
}
function $t(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ve(e, t, n) {
  return xe(e, ht(t, n));
}
function br(e, t, n) {
  var r = Ve(e, t, n);
  return r > n ? n : r;
}
function En() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function xn(e) {
  return Object.assign({}, En(), e);
}
function Sn(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var wr = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, xn(typeof t != "number" ? t : Sn(t, Ke));
};
function Or(e) {
  var t, n = e.state, r = e.name, i = e.options, o = n.elements.arrow, s = n.modifiersData.popperOffsets, u = re(n.placement), c = $t(u), f = [Y, Z].indexOf(u) >= 0, p = f ? "height" : "width";
  if (!(!o || !s)) {
    var v = wr(i.padding, n), b = Mt(o), g = c === "y" ? U : Y, O = c === "y" ? J : Z, y = n.rects.reference[p] + n.rects.reference[c] - s[c] - n.rects.popper[p], E = s[c] - n.rects.reference[c], A = Je(o), R = A ? c === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, j = y / 2 - E / 2, a = v[g], k = R - b[p] - v[O], h = R / 2 - b[p] / 2 + j, z = Ve(a, h, k), B = c;
    n.modifiersData[r] = (t = {}, t[B] = z, t.centerOffset = z - h, t);
  }
}
function Er(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || On(t.elements.popper, i) && (t.elements.arrow = i));
}
const xr = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Or,
  effect: Er,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function je(e) {
  return e.split("-")[1];
}
var Sr = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Tr(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: ze(n * i) / i || 0,
    y: ze(r * i) / i || 0
  };
}
function Xt(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, o = e.variation, s = e.offsets, u = e.position, c = e.gpuAcceleration, f = e.adaptive, p = e.roundOffsets, v = e.isFixed, b = s.x, g = b === void 0 ? 0 : b, O = s.y, y = O === void 0 ? 0 : O, E = typeof p == "function" ? p({
    x: g,
    y
  }) : {
    x: g,
    y
  };
  g = E.x, y = E.y;
  var A = s.hasOwnProperty("x"), R = s.hasOwnProperty("y"), j = Y, a = U, k = window;
  if (f) {
    var h = Je(n), z = "clientHeight", B = "clientWidth";
    if (h === X(n) && (h = me(n), de(h).position !== "static" && u === "absolute" && (z = "scrollHeight", B = "scrollWidth")), h = h, i === U || (i === Y || i === Z) && o === Ye) {
      a = J;
      var C = v && h === k && k.visualViewport ? k.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        h[z]
      );
      y -= C - r.height, y *= c ? 1 : -1;
    }
    if (i === Y || (i === U || i === J) && o === Ye) {
      j = Z;
      var S = v && h === k && k.visualViewport ? k.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        h[B]
      );
      g -= S - r.width, g *= c ? 1 : -1;
    }
  }
  var T = Object.assign({
    position: u
  }, f && Sr), L = p === !0 ? Tr({
    x: g,
    y
  }, X(n)) : {
    x: g,
    y
  };
  if (g = L.x, y = L.y, c) {
    var D;
    return Object.assign({}, T, (D = {}, D[a] = R ? "0" : "", D[j] = A ? "0" : "", D.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + y + "px)" : "translate3d(" + g + "px, " + y + "px, 0)", D));
  }
  return Object.assign({}, T, (t = {}, t[a] = R ? y + "px" : "", t[j] = A ? g + "px" : "", t.transform = "", t));
}
function kr(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, o = n.adaptive, s = o === void 0 ? !0 : o, u = n.roundOffsets, c = u === void 0 ? !0 : u, f = {
    placement: re(t.placement),
    variation: je(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Xt(Object.assign({}, f, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Xt(Object.assign({}, f, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Cr = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: kr,
  data: {}
};
var pt = {
  passive: !0
};
function Ar(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, o = i === void 0 ? !0 : i, s = r.resize, u = s === void 0 ? !0 : s, c = X(t.elements.popper), f = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && f.forEach(function(p) {
    p.addEventListener("scroll", n.update, pt);
  }), u && c.addEventListener("resize", n.update, pt), function() {
    o && f.forEach(function(p) {
      p.removeEventListener("scroll", n.update, pt);
    }), u && c.removeEventListener("resize", n.update, pt);
  };
}
const Dr = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Ar,
  data: {}
};
var _r = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function dt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return _r[t];
  });
}
var Nr = {
  start: "end",
  end: "start"
};
function Gt(e) {
  return e.replace(/start|end/g, function(t) {
    return Nr[t];
  });
}
function It(e) {
  var t = X(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Wt(e) {
  return Pe(me(e)).left + It(e).scrollLeft;
}
function Rr(e, t) {
  var n = X(e), r = me(e), i = n.visualViewport, o = r.clientWidth, s = r.clientHeight, u = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    var f = wn();
    (f || !f && t === "fixed") && (u = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: u + Wt(e),
    y: c
  };
}
function Lr(e) {
  var t, n = me(e), r = It(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = xe(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = xe(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), u = -r.scrollLeft + Wt(e), c = -r.scrollTop;
  return de(i || n).direction === "rtl" && (u += xe(n.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: u,
    y: c
  };
}
function Ht(e) {
  var t = de(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function Tn(e) {
  return ["html", "body", "#document"].indexOf(ie(e)) >= 0 ? e.ownerDocument.body : K(e) && Ht(e) ? e : Tn(yt(e));
}
function Fe(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Tn(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = X(r), s = i ? [o].concat(o.visualViewport || [], Ht(r) ? r : []) : r, u = t.concat(s);
  return i ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(Fe(yt(s)))
  );
}
function _t(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function zr(e, t) {
  var n = Pe(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Kt(e, t, n) {
  return t === gn ? _t(Rr(e, n)) : Se(t) ? zr(t, n) : _t(Lr(me(e)));
}
function Pr(e) {
  var t = Fe(yt(e)), n = ["absolute", "fixed"].indexOf(de(e).position) >= 0, r = n && K(e) ? Je(e) : e;
  return Se(r) ? t.filter(function(i) {
    return Se(i) && On(i, r) && ie(i) !== "body";
  }) : [];
}
function jr(e, t, n, r) {
  var i = t === "clippingParents" ? Pr(e) : [].concat(t), o = [].concat(i, [n]), s = o[0], u = o.reduce(function(c, f) {
    var p = Kt(e, f, r);
    return c.top = xe(p.top, c.top), c.right = ht(p.right, c.right), c.bottom = ht(p.bottom, c.bottom), c.left = xe(p.left, c.left), c;
  }, Kt(e, s, r));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function kn(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? re(r) : null, o = r ? je(r) : null, s = t.x + t.width / 2 - n.width / 2, u = t.y + t.height / 2 - n.height / 2, c;
  switch (i) {
    case U:
      c = {
        x: s,
        y: t.y - n.height
      };
      break;
    case J:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case Z:
      c = {
        x: t.x + t.width,
        y: u
      };
      break;
    case Y:
      c = {
        x: t.x - n.width,
        y: u
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var f = i ? $t(i) : null;
  if (f != null) {
    var p = f === "y" ? "height" : "width";
    switch (o) {
      case Le:
        c[f] = c[f] - (t[p] / 2 - n[p] / 2);
        break;
      case Ye:
        c[f] = c[f] + (t[p] / 2 - n[p] / 2);
        break;
    }
  }
  return c;
}
function Qe(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, o = n.strategy, s = o === void 0 ? e.strategy : o, u = n.boundary, c = u === void 0 ? rr : u, f = n.rootBoundary, p = f === void 0 ? gn : f, v = n.elementContext, b = v === void 0 ? We : v, g = n.altBoundary, O = g === void 0 ? !1 : g, y = n.padding, E = y === void 0 ? 0 : y, A = xn(typeof E != "number" ? E : Sn(E, Ke)), R = b === We ? ir : We, j = e.rects.popper, a = e.elements[O ? R : b], k = jr(Se(a) ? a : a.contextElement || me(e.elements.popper), c, p, s), h = Pe(e.elements.reference), z = kn({
    reference: h,
    element: j,
    strategy: "absolute",
    placement: i
  }), B = _t(Object.assign({}, j, z)), C = b === We ? B : h, S = {
    top: k.top - C.top + A.top,
    bottom: C.bottom - k.bottom + A.bottom,
    left: k.left - C.left + A.left,
    right: C.right - k.right + A.right
  }, T = e.modifiersData.offset;
  if (b === We && T) {
    var L = T[i];
    Object.keys(S).forEach(function(D) {
      var N = [Z, J].indexOf(D) >= 0 ? 1 : -1, x = [U, J].indexOf(D) >= 0 ? "y" : "x";
      S[D] += L[x] * N;
    });
  }
  return S;
}
function Br(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, o = n.rootBoundary, s = n.padding, u = n.flipVariations, c = n.allowedAutoPlacements, f = c === void 0 ? yn : c, p = je(r), v = p ? u ? Yt : Yt.filter(function(O) {
    return je(O) === p;
  }) : Ke, b = v.filter(function(O) {
    return f.indexOf(O) >= 0;
  });
  b.length === 0 && (b = v);
  var g = b.reduce(function(O, y) {
    return O[y] = Qe(e, {
      placement: y,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[re(y)], O;
  }, {});
  return Object.keys(g).sort(function(O, y) {
    return g[O] - g[y];
  });
}
function qr(e) {
  if (re(e) === Bt)
    return [];
  var t = dt(e);
  return [Gt(e), t, Gt(t)];
}
function Mr(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, u = s === void 0 ? !0 : s, c = n.fallbackPlacements, f = n.padding, p = n.boundary, v = n.rootBoundary, b = n.altBoundary, g = n.flipVariations, O = g === void 0 ? !0 : g, y = n.allowedAutoPlacements, E = t.options.placement, A = re(E), R = A === E, j = c || (R || !O ? [dt(E)] : qr(E)), a = [E].concat(j).reduce(function(oe, ee) {
      return oe.concat(re(ee) === Bt ? Br(t, {
        placement: ee,
        boundary: p,
        rootBoundary: v,
        padding: f,
        flipVariations: O,
        allowedAutoPlacements: y
      }) : ee);
    }, []), k = t.rects.reference, h = t.rects.popper, z = /* @__PURE__ */ new Map(), B = !0, C = a[0], S = 0; S < a.length; S++) {
      var T = a[S], L = re(T), D = je(T) === Le, N = [U, J].indexOf(L) >= 0, x = N ? "width" : "height", I = Qe(t, {
        placement: T,
        boundary: p,
        rootBoundary: v,
        altBoundary: b,
        padding: f
      }), $ = N ? D ? Z : Y : D ? J : U;
      k[x] > h[x] && ($ = dt($));
      var M = dt($), H = [];
      if (o && H.push(I[L] <= 0), u && H.push(I[$] <= 0, I[M] <= 0), H.every(function(oe) {
        return oe;
      })) {
        C = T, B = !1;
        break;
      }
      z.set(T, H);
    }
    if (B)
      for (var W = O ? 3 : 1, ge = function(ee) {
        var ae = a.find(function(Te) {
          var se = z.get(Te);
          if (se)
            return se.slice(0, ee).every(function(ke) {
              return ke;
            });
        });
        if (ae)
          return C = ae, "break";
      }, te = W; te > 0; te--) {
        var ye = ge(te);
        if (ye === "break")
          break;
      }
    t.placement !== C && (t.modifiersData[r]._skip = !0, t.placement = C, t.reset = !0);
  }
}
const $r = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Mr,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Jt(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Zt(e) {
  return [U, Z, J, Y].some(function(t) {
    return e[t] >= 0;
  });
}
function Ir(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, s = Qe(t, {
    elementContext: "reference"
  }), u = Qe(t, {
    altBoundary: !0
  }), c = Jt(s, r), f = Jt(u, i, o), p = Zt(c), v = Zt(f);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: f,
    isReferenceHidden: p,
    hasPopperEscaped: v
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": p,
    "data-popper-escaped": v
  });
}
const Wr = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Ir
};
function Hr(e, t, n) {
  var r = re(e), i = [Y, U].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = o[0], u = o[1];
  return s = s || 0, u = (u || 0) * i, [Y, Z].indexOf(r) >= 0 ? {
    x: u,
    y: s
  } : {
    x: s,
    y: u
  };
}
function Vr(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, o = i === void 0 ? [0, 0] : i, s = yn.reduce(function(p, v) {
    return p[v] = Hr(v, t.rects, o), p;
  }, {}), u = s[t.placement], c = u.x, f = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += f), t.modifiersData[r] = s;
}
const Fr = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Vr
};
function Ur(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = kn({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Yr = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ur,
  data: {}
};
function Qr(e) {
  return e === "x" ? "y" : "x";
}
function Xr(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, u = s === void 0 ? !1 : s, c = n.boundary, f = n.rootBoundary, p = n.altBoundary, v = n.padding, b = n.tether, g = b === void 0 ? !0 : b, O = n.tetherOffset, y = O === void 0 ? 0 : O, E = Qe(t, {
    boundary: c,
    rootBoundary: f,
    padding: v,
    altBoundary: p
  }), A = re(t.placement), R = je(t.placement), j = !R, a = $t(A), k = Qr(a), h = t.modifiersData.popperOffsets, z = t.rects.reference, B = t.rects.popper, C = typeof y == "function" ? y(Object.assign({}, t.rects, {
    placement: t.placement
  })) : y, S = typeof C == "number" ? {
    mainAxis: C,
    altAxis: C
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, C), T = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (h) {
    if (o) {
      var D, N = a === "y" ? U : Y, x = a === "y" ? J : Z, I = a === "y" ? "height" : "width", $ = h[a], M = $ + E[N], H = $ - E[x], W = g ? -B[I] / 2 : 0, ge = R === Le ? z[I] : B[I], te = R === Le ? -B[I] : -z[I], ye = t.elements.arrow, oe = g && ye ? Mt(ye) : {
        width: 0,
        height: 0
      }, ee = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : En(), ae = ee[N], Te = ee[x], se = Ve(0, z[I], oe[I]), ke = j ? z[I] / 2 - W - se - ae - S.mainAxis : ge - se - ae - S.mainAxis, ve = j ? -z[I] / 2 + W + se + Te + S.mainAxis : te + se + Te + S.mainAxis, Ce = t.elements.arrow && Je(t.elements.arrow), et = Ce ? a === "y" ? Ce.clientTop || 0 : Ce.clientLeft || 0 : 0, Be = (D = T?.[a]) != null ? D : 0, tt = $ + ke - Be - et, nt = $ + ve - Be, qe = Ve(g ? ht(M, tt) : M, $, g ? xe(H, nt) : H);
      h[a] = qe, L[a] = qe - $;
    }
    if (u) {
      var Me, rt = a === "x" ? U : Y, it = a === "x" ? J : Z, ce = h[k], he = k === "y" ? "height" : "width", $e = ce + E[rt], be = ce - E[it], Ie = [U, Y].indexOf(A) !== -1, ot = (Me = T?.[k]) != null ? Me : 0, at = Ie ? $e : ce - z[he] - B[he] - ot + S.altAxis, st = Ie ? ce + z[he] + B[he] - ot - S.altAxis : be, ct = g && Ie ? br(at, ce, st) : Ve(g ? at : $e, ce, g ? st : be);
      h[k] = ct, L[k] = ct - ce;
    }
    t.modifiersData[r] = L;
  }
}
const Gr = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Xr,
  requiresIfExists: ["offset"]
};
function Kr(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Jr(e) {
  return e === X(e) || !K(e) ? It(e) : Kr(e);
}
function Zr(e) {
  var t = e.getBoundingClientRect(), n = ze(t.width) / e.offsetWidth || 1, r = ze(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function ei(e, t, n) {
  n === void 0 && (n = !1);
  var r = K(t), i = K(t) && Zr(t), o = me(t), s = Pe(e, i, n), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ie(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ht(o)) && (u = Jr(t)), K(t) ? (c = Pe(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : o && (c.x = Wt(o))), {
    x: s.left + u.scrollLeft - c.x,
    y: s.top + u.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function ti(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    n.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(u) {
      if (!n.has(u)) {
        var c = t.get(u);
        c && i(c);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || i(o);
  }), r;
}
function ni(e) {
  var t = ti(e);
  return vr.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function ri(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function ii(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var en = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function tn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function oi(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, o = i === void 0 ? en : i;
  return function(u, c, f) {
    f === void 0 && (f = o);
    var p = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, en, o),
      modifiersData: {},
      elements: {
        reference: u,
        popper: c
      },
      attributes: {},
      styles: {}
    }, v = [], b = !1, g = {
      state: p,
      setOptions: function(A) {
        var R = typeof A == "function" ? A(p.options) : A;
        y(), p.options = Object.assign({}, o, p.options, R), p.scrollParents = {
          reference: Se(u) ? Fe(u) : u.contextElement ? Fe(u.contextElement) : [],
          popper: Fe(c)
        };
        var j = ni(ii([].concat(r, p.options.modifiers)));
        return p.orderedModifiers = j.filter(function(a) {
          return a.enabled;
        }), O(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var A = p.elements, R = A.reference, j = A.popper;
          if (tn(R, j)) {
            p.rects = {
              reference: ei(R, Je(j), p.options.strategy === "fixed"),
              popper: Mt(j)
            }, p.reset = !1, p.placement = p.options.placement, p.orderedModifiers.forEach(function(S) {
              return p.modifiersData[S.name] = Object.assign({}, S.data);
            });
            for (var a = 0; a < p.orderedModifiers.length; a++) {
              if (p.reset === !0) {
                p.reset = !1, a = -1;
                continue;
              }
              var k = p.orderedModifiers[a], h = k.fn, z = k.options, B = z === void 0 ? {} : z, C = k.name;
              typeof h == "function" && (p = h({
                state: p,
                options: B,
                name: C,
                instance: g
              }) || p);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: ri(function() {
        return new Promise(function(E) {
          g.forceUpdate(), E(p);
        });
      }),
      destroy: function() {
        y(), b = !0;
      }
    };
    if (!tn(u, c))
      return g;
    g.setOptions(f).then(function(E) {
      !b && f.onFirstUpdate && f.onFirstUpdate(E);
    });
    function O() {
      p.orderedModifiers.forEach(function(E) {
        var A = E.name, R = E.options, j = R === void 0 ? {} : R, a = E.effect;
        if (typeof a == "function") {
          var k = a({
            state: p,
            name: A,
            instance: g,
            options: j
          }), h = function() {
          };
          v.push(k || h);
        }
      });
    }
    function y() {
      v.forEach(function(E) {
        return E();
      }), v = [];
    }
    return g;
  };
}
var ai = [Dr, Yr, Cr, bn, Fr, $r, Gr, xr, Wr], si = /* @__PURE__ */ oi({
  defaultModifiers: ai
}), ci = "tippy-box", Cn = "tippy-content", ui = "tippy-backdrop", An = "tippy-arrow", Dn = "tippy-svg-arrow", Oe = {
  passive: !0,
  capture: !0
}, _n = function() {
  return document.body;
};
function li(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function St(e, t, n) {
  if (Array.isArray(e)) {
    var r = e[t];
    return r ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function Vt(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function Nn(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function nn(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      e(r);
    }, t);
  };
}
function pi(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(r) {
    delete n[r];
  }), n;
}
function fi(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Ne(e) {
  return [].concat(e);
}
function rn(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function di(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function vi(e) {
  return e.split("-")[0];
}
function mt(e) {
  return [].slice.call(e);
}
function on(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function Ue() {
  return document.createElement("div");
}
function Xe(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Vt(e, t);
  });
}
function hi(e) {
  return Vt(e, "NodeList");
}
function mi(e) {
  return Vt(e, "MouseEvent");
}
function gi(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function yi(e) {
  return Xe(e) ? [e] : hi(e) ? mt(e) : Array.isArray(e) ? e : mt(document.querySelectorAll(e));
}
function Tt(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function an(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function bi(e) {
  var t, n = Ne(e), r = n[0];
  return r != null && (t = r.ownerDocument) != null && t.body ? r.ownerDocument : document;
}
function wi(e, t) {
  var n = t.clientX, r = t.clientY;
  return e.every(function(i) {
    var o = i.popperRect, s = i.popperState, u = i.props, c = u.interactiveBorder, f = vi(s.placement), p = s.modifiersData.offset;
    if (!p)
      return !0;
    var v = f === "bottom" ? p.top.y : 0, b = f === "top" ? p.bottom.y : 0, g = f === "right" ? p.left.x : 0, O = f === "left" ? p.right.x : 0, y = o.top - r + v > c, E = r - o.bottom - b > c, A = o.left - n + g > c, R = n - o.right - O > c;
    return y || E || A || R;
  });
}
function kt(e, t, n) {
  var r = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    e[r](i, n);
  });
}
function sn(e, t) {
  for (var n = t; n; ) {
    var r;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var ne = {
  isTouch: !1
}, cn = 0;
function Oi() {
  ne.isTouch || (ne.isTouch = !0, window.performance && document.addEventListener("mousemove", Rn));
}
function Rn() {
  var e = performance.now();
  e - cn < 20 && (ne.isTouch = !1, document.removeEventListener("mousemove", Rn)), cn = e;
}
function Ei() {
  var e = document.activeElement;
  if (gi(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function xi() {
  document.addEventListener("touchstart", Oi, Oe), window.addEventListener("blur", Ei);
}
var Si = typeof window < "u" && typeof document < "u", Ti = Si ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function _e(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function un(e) {
  var t = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return e.replace(t, " ").replace(n, "").trim();
}
function ki(e) {
  return un(`
  %ctippy.js

  %c` + un(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function Ln(e) {
  return [
    ki(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Ge;
 false && 0;
function Ci() {
  Ge = /* @__PURE__ */ new Set();
}
function ue(e, t) {
  if (e && !Ge.has(t)) {
    var n;
    Ge.add(t), (n = console).warn.apply(n, Ln(t));
  }
}
function Nt(e, t) {
  if (e && !Ge.has(t)) {
    var n;
    Ge.add(t), (n = console).error.apply(n, Ln(t));
  }
}
function Ai(e) {
  var t = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  Nt(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Nt(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var zn = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Di = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Q = Object.assign({
  appendTo: _n,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, zn, Di), _i = Object.keys(Q), Ni = function(t) {
   false && 0;
  var n = Object.keys(t);
  n.forEach(function(r) {
    Q[r] = t[r];
  });
};
function Pn(e) {
  var t = e.plugins || [], n = t.reduce(function(r, i) {
    var o = i.name, s = i.defaultValue;
    if (o) {
      var u;
      r[o] = e[o] !== void 0 ? e[o] : (u = Q[o]) != null ? u : s;
    }
    return r;
  }, {});
  return Object.assign({}, e, n);
}
function Ri(e, t) {
  var n = t ? Object.keys(Pn(Object.assign({}, Q, {
    plugins: t
  }))) : _i, r = n.reduce(function(i, o) {
    var s = (e.getAttribute("data-tippy-" + o) || "").trim();
    if (!s)
      return i;
    if (o === "content")
      i[o] = s;
    else
      try {
        i[o] = JSON.parse(s);
      } catch {
        i[o] = s;
      }
    return i;
  }, {});
  return r;
}
function ln(e, t) {
  var n = Object.assign({}, t, {
    content: Nn(t.content, [e])
  }, t.ignoreAttributes ? {} : Ri(e, t.plugins));
  return n.aria = Object.assign({}, Q.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function jn(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    var i = pi(Q, Object.keys(zn)), o = !li(i, r);
    o && (o = t.filter(function(s) {
      return s.name === r;
    }).length === 0), ue(o, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Li = function() {
  return "innerHTML";
};
function Rt(e, t) {
  e[Li()] = t;
}
function pn(e) {
  var t = Ue();
  return e === !0 ? t.className = An : (t.className = Dn, Xe(e) ? t.appendChild(e) : Rt(t, e)), t;
}
function fn(e, t) {
  Xe(t.content) ? (Rt(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Rt(e, t.content) : e.textContent = t.content);
}
function Lt(e) {
  var t = e.firstElementChild, n = mt(t.children);
  return {
    box: t,
    content: n.find(function(r) {
      return r.classList.contains(Cn);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(An) || r.classList.contains(Dn);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(ui);
    })
  };
}
function Bn(e) {
  var t = Ue(), n = Ue();
  n.className = ci, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Ue();
  r.className = Cn, r.setAttribute("data-state", "hidden"), fn(r, e.props), t.appendChild(n), n.appendChild(r), i(e.props, e.props);
  function i(o, s) {
    var u = Lt(t), c = u.box, f = u.content, p = u.arrow;
    s.theme ? c.setAttribute("data-theme", s.theme) : c.removeAttribute("data-theme"), typeof s.animation == "string" ? c.setAttribute("data-animation", s.animation) : c.removeAttribute("data-animation"), s.inertia ? c.setAttribute("data-inertia", "") : c.removeAttribute("data-inertia"), c.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? c.setAttribute("role", s.role) : c.removeAttribute("role"), (o.content !== s.content || o.allowHTML !== s.allowHTML) && fn(f, e.props), s.arrow ? p ? o.arrow !== s.arrow && (c.removeChild(p), c.appendChild(pn(s.arrow))) : c.appendChild(pn(s.arrow)) : p && c.removeChild(p);
  }
  return {
    popper: t,
    onUpdate: i
  };
}
Bn.$$tippy = !0;
var zi = 1, ft = [], Ct = [];
function Pi(e, t) {
  var n = ln(e, Object.assign({}, Q, Pn(on(t)))), r, i, o, s = !1, u = !1, c = !1, f = !1, p, v, b, g = [], O = nn(tt, n.interactiveDebounce), y, E = zi++, A = null, R = di(n.plugins), j = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, a = {
    // properties
    id: E,
    reference: e,
    popper: Ue(),
    popperInstance: A,
    props: n,
    state: j,
    plugins: R,
    // methods
    clearDelayTimeouts: at,
    setProps: st,
    setContent: ct,
    show: Fn,
    hide: Un,
    hideWithInteractivity: Yn,
    enable: Ie,
    disable: ot,
    unmount: Qn,
    destroy: Xn
  };
  if (!n.render)
    return  false && 0, a;
  var k = n.render(a), h = k.popper, z = k.onUpdate;
  h.setAttribute("data-tippy-root", ""), h.id = "tippy-" + a.id, a.popper = h, e._tippy = a, h._tippy = a;
  var B = R.map(function(l) {
    return l.fn(a);
  }), C = e.hasAttribute("aria-expanded");
  return Ce(), W(), $(), M("onCreate", [a]), n.showOnCreate && $e(), h.addEventListener("mouseenter", function() {
    a.props.interactive && a.state.isVisible && a.clearDelayTimeouts();
  }), h.addEventListener("mouseleave", function() {
    a.props.interactive && a.props.trigger.indexOf("mouseenter") >= 0 && N().addEventListener("mousemove", O);
  }), a;
  function S() {
    var l = a.props.touch;
    return Array.isArray(l) ? l : [l, 0];
  }
  function T() {
    return S()[0] === "hold";
  }
  function L() {
    var l;
    return !!((l = a.props.render) != null && l.$$tippy);
  }
  function D() {
    return y || e;
  }
  function N() {
    var l = D().parentNode;
    return l ? bi(l) : document;
  }
  function x() {
    return Lt(h);
  }
  function I(l) {
    return a.state.isMounted && !a.state.isVisible || ne.isTouch || p && p.type === "focus" ? 0 : St(a.props.delay, l ? 0 : 1, Q.delay);
  }
  function $(l) {
    l === void 0 && (l = !1), h.style.pointerEvents = a.props.interactive && !l ? "" : "none", h.style.zIndex = "" + a.props.zIndex;
  }
  function M(l, m, w) {
    if (w === void 0 && (w = !0), B.forEach(function(_) {
      _[l] && _[l].apply(_, m);
    }), w) {
      var P;
      (P = a.props)[l].apply(P, m);
    }
  }
  function H() {
    var l = a.props.aria;
    if (l.content) {
      var m = "aria-" + l.content, w = h.id, P = Ne(a.props.triggerTarget || e);
      P.forEach(function(_) {
        var F = _.getAttribute(m);
        if (a.state.isVisible)
          _.setAttribute(m, F ? F + " " + w : w);
        else {
          var G = F && F.replace(w, "").trim();
          G ? _.setAttribute(m, G) : _.removeAttribute(m);
        }
      });
    }
  }
  function W() {
    if (!(C || !a.props.aria.expanded)) {
      var l = Ne(a.props.triggerTarget || e);
      l.forEach(function(m) {
        a.props.interactive ? m.setAttribute("aria-expanded", a.state.isVisible && m === D() ? "true" : "false") : m.removeAttribute("aria-expanded");
      });
    }
  }
  function ge() {
    N().removeEventListener("mousemove", O), ft = ft.filter(function(l) {
      return l !== O;
    });
  }
  function te(l) {
    if (!(ne.isTouch && (c || l.type === "mousedown"))) {
      var m = l.composedPath && l.composedPath()[0] || l.target;
      if (!(a.props.interactive && sn(h, m))) {
        if (Ne(a.props.triggerTarget || e).some(function(w) {
          return sn(w, m);
        })) {
          if (ne.isTouch || a.state.isVisible && a.props.trigger.indexOf("click") >= 0)
            return;
        } else
          M("onClickOutside", [a, l]);
        a.props.hideOnClick === !0 && (a.clearDelayTimeouts(), a.hide(), u = !0, setTimeout(function() {
          u = !1;
        }), a.state.isMounted || ae());
      }
    }
  }
  function ye() {
    c = !0;
  }
  function oe() {
    c = !1;
  }
  function ee() {
    var l = N();
    l.addEventListener("mousedown", te, !0), l.addEventListener("touchend", te, Oe), l.addEventListener("touchstart", oe, Oe), l.addEventListener("touchmove", ye, Oe);
  }
  function ae() {
    var l = N();
    l.removeEventListener("mousedown", te, !0), l.removeEventListener("touchend", te, Oe), l.removeEventListener("touchstart", oe, Oe), l.removeEventListener("touchmove", ye, Oe);
  }
  function Te(l, m) {
    ke(l, function() {
      !a.state.isVisible && h.parentNode && h.parentNode.contains(h) && m();
    });
  }
  function se(l, m) {
    ke(l, m);
  }
  function ke(l, m) {
    var w = x().box;
    function P(_) {
      _.target === w && (kt(w, "remove", P), m());
    }
    if (l === 0)
      return m();
    kt(w, "remove", v), kt(w, "add", P), v = P;
  }
  function ve(l, m, w) {
    w === void 0 && (w = !1);
    var P = Ne(a.props.triggerTarget || e);
    P.forEach(function(_) {
      _.addEventListener(l, m, w), g.push({
        node: _,
        eventType: l,
        handler: m,
        options: w
      });
    });
  }
  function Ce() {
    T() && (ve("touchstart", Be, {
      passive: !0
    }), ve("touchend", nt, {
      passive: !0
    })), fi(a.props.trigger).forEach(function(l) {
      if (l !== "manual")
        switch (ve(l, Be), l) {
          case "mouseenter":
            ve("mouseleave", nt);
            break;
          case "focus":
            ve(Ti ? "focusout" : "blur", qe);
            break;
          case "focusin":
            ve("focusout", qe);
            break;
        }
    });
  }
  function et() {
    g.forEach(function(l) {
      var m = l.node, w = l.eventType, P = l.handler, _ = l.options;
      m.removeEventListener(w, P, _);
    }), g = [];
  }
  function Be(l) {
    var m, w = !1;
    if (!(!a.state.isEnabled || Me(l) || u)) {
      var P = ((m = p) == null ? void 0 : m.type) === "focus";
      p = l, y = l.currentTarget, W(), !a.state.isVisible && mi(l) && ft.forEach(function(_) {
        return _(l);
      }), l.type === "click" && (a.props.trigger.indexOf("mouseenter") < 0 || s) && a.props.hideOnClick !== !1 && a.state.isVisible ? w = !0 : $e(l), l.type === "click" && (s = !w), w && !P && be(l);
    }
  }
  function tt(l) {
    var m = l.target, w = D().contains(m) || h.contains(m);
    if (!(l.type === "mousemove" && w)) {
      var P = he().concat(h).map(function(_) {
        var F, G = _._tippy, Ae = (F = G.popperInstance) == null ? void 0 : F.state;
        return Ae ? {
          popperRect: _.getBoundingClientRect(),
          popperState: Ae,
          props: n
        } : null;
      }).filter(Boolean);
      wi(P, l) && (ge(), be(l));
    }
  }
  function nt(l) {
    var m = Me(l) || a.props.trigger.indexOf("click") >= 0 && s;
    if (!m) {
      if (a.props.interactive) {
        a.hideWithInteractivity(l);
        return;
      }
      be(l);
    }
  }
  function qe(l) {
    a.props.trigger.indexOf("focusin") < 0 && l.target !== D() || a.props.interactive && l.relatedTarget && h.contains(l.relatedTarget) || be(l);
  }
  function Me(l) {
    return ne.isTouch ? T() !== l.type.indexOf("touch") >= 0 : !1;
  }
  function rt() {
    it();
    var l = a.props, m = l.popperOptions, w = l.placement, P = l.offset, _ = l.getReferenceClientRect, F = l.moveTransition, G = L() ? Lt(h).arrow : null, Ae = _ ? {
      getBoundingClientRect: _,
      contextElement: _.contextElement || D()
    } : e, Ft = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(ut) {
        var De = ut.state;
        if (L()) {
          var Gn = x(), xt = Gn.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(lt) {
            lt === "placement" ? xt.setAttribute("data-placement", De.placement) : De.attributes.popper["data-popper-" + lt] ? xt.setAttribute("data-" + lt, "") : xt.removeAttribute("data-" + lt);
          }), De.attributes.popper = {};
        }
      }
    }, we = [{
      name: "offset",
      options: {
        offset: P
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !F
      }
    }, Ft];
    L() && G && we.push({
      name: "arrow",
      options: {
        element: G,
        padding: 3
      }
    }), we.push.apply(we, m?.modifiers || []), a.popperInstance = si(Ae, h, Object.assign({}, m, {
      placement: w,
      onFirstUpdate: b,
      modifiers: we
    }));
  }
  function it() {
    a.popperInstance && (a.popperInstance.destroy(), a.popperInstance = null);
  }
  function ce() {
    var l = a.props.appendTo, m, w = D();
    a.props.interactive && l === _n || l === "parent" ? m = w.parentNode : m = Nn(l, [w]), m.contains(h) || m.appendChild(h), a.state.isMounted = !0, rt(),  false && 0;
  }
  function he() {
    return mt(h.querySelectorAll("[data-tippy-root]"));
  }
  function $e(l) {
    a.clearDelayTimeouts(), l && M("onTrigger", [a, l]), ee();
    var m = I(!0), w = S(), P = w[0], _ = w[1];
    ne.isTouch && P === "hold" && _ && (m = _), m ? r = setTimeout(function() {
      a.show();
    }, m) : a.show();
  }
  function be(l) {
    if (a.clearDelayTimeouts(), M("onUntrigger", [a, l]), !a.state.isVisible) {
      ae();
      return;
    }
    if (!(a.props.trigger.indexOf("mouseenter") >= 0 && a.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(l.type) >= 0 && s)) {
      var m = I(!1);
      m ? i = setTimeout(function() {
        a.state.isVisible && a.hide();
      }, m) : o = requestAnimationFrame(function() {
        a.hide();
      });
    }
  }
  function Ie() {
    a.state.isEnabled = !0;
  }
  function ot() {
    a.hide(), a.state.isEnabled = !1;
  }
  function at() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(o);
  }
  function st(l) {
    if ( false && 0, !a.state.isDestroyed) {
      M("onBeforeUpdate", [a, l]), et();
      var m = a.props, w = ln(e, Object.assign({}, m, on(l), {
        ignoreAttributes: !0
      }));
      a.props = w, Ce(), m.interactiveDebounce !== w.interactiveDebounce && (ge(), O = nn(tt, w.interactiveDebounce)), m.triggerTarget && !w.triggerTarget ? Ne(m.triggerTarget).forEach(function(P) {
        P.removeAttribute("aria-expanded");
      }) : w.triggerTarget && e.removeAttribute("aria-expanded"), W(), $(), z && z(m, w), a.popperInstance && (rt(), he().forEach(function(P) {
        requestAnimationFrame(P._tippy.popperInstance.forceUpdate);
      })), M("onAfterUpdate", [a, l]);
    }
  }
  function ct(l) {
    a.setProps({
      content: l
    });
  }
  function Fn() {
     false && 0;
    var l = a.state.isVisible, m = a.state.isDestroyed, w = !a.state.isEnabled, P = ne.isTouch && !a.props.touch, _ = St(a.props.duration, 0, Q.duration);
    if (!(l || m || w || P) && !D().hasAttribute("disabled") && (M("onShow", [a], !1), a.props.onShow(a) !== !1)) {
      if (a.state.isVisible = !0, L() && (h.style.visibility = "visible"), $(), ee(), a.state.isMounted || (h.style.transition = "none"), L()) {
        var F = x(), G = F.box, Ae = F.content;
        Tt([G, Ae], 0);
      }
      b = function() {
        var we;
        if (!(!a.state.isVisible || f)) {
          if (f = !0, h.offsetHeight, h.style.transition = a.props.moveTransition, L() && a.props.animation) {
            var Et = x(), ut = Et.box, De = Et.content;
            Tt([ut, De], _), an([ut, De], "visible");
          }
          H(), W(), rn(Ct, a), (we = a.popperInstance) == null || we.forceUpdate(), M("onMount", [a]), a.props.animation && L() && se(_, function() {
            a.state.isShown = !0, M("onShown", [a]);
          });
        }
      }, ce();
    }
  }
  function Un() {
     false && 0;
    var l = !a.state.isVisible, m = a.state.isDestroyed, w = !a.state.isEnabled, P = St(a.props.duration, 1, Q.duration);
    if (!(l || m || w) && (M("onHide", [a], !1), a.props.onHide(a) !== !1)) {
      if (a.state.isVisible = !1, a.state.isShown = !1, f = !1, s = !1, L() && (h.style.visibility = "hidden"), ge(), ae(), $(!0), L()) {
        var _ = x(), F = _.box, G = _.content;
        a.props.animation && (Tt([F, G], P), an([F, G], "hidden"));
      }
      H(), W(), a.props.animation ? L() && Te(P, a.unmount) : a.unmount();
    }
  }
  function Yn(l) {
     false && 0, N().addEventListener("mousemove", O), rn(ft, O), O(l);
  }
  function Qn() {
     false && 0, a.state.isVisible && a.hide(), a.state.isMounted && (it(), he().forEach(function(l) {
      l._tippy.unmount();
    }), h.parentNode && h.parentNode.removeChild(h), Ct = Ct.filter(function(l) {
      return l !== a;
    }), a.state.isMounted = !1, M("onHidden", [a]));
  }
  function Xn() {
     false && 0, !a.state.isDestroyed && (a.clearDelayTimeouts(), a.unmount(), et(), delete e._tippy, a.state.isDestroyed = !0, M("onDestroy", [a]));
  }
}
function Ze(e, t) {
  t === void 0 && (t = {});
  var n = Q.plugins.concat(t.plugins || []);
   false && (0), xi();
  var r = Object.assign({}, t, {
    plugins: n
  }), i = yi(e);
  if (false) { var o, s; }
  var u = i.reduce(function(c, f) {
    var p = f && Pi(f, r);
    return p && c.push(p), c;
  }, []);
  return Xe(e) ? u[0] : u;
}
Ze.defaultProps = Q;
Ze.setDefaultProps = Ni;
Ze.currentInput = ne;
Object.assign({}, bn, {
  effect: function(t) {
    var n = t.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
Ze.setDefaultProps({
  render: Bn
});
function qn(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Mn = typeof window < "u" && typeof document < "u";
function zt(e, t) {
  e && (typeof e == "function" && e(t), {}.hasOwnProperty.call(e, "current") && (e.current = t));
}
function dn() {
  return Mn && document.createElement("div");
}
function ji(e) {
  var t = {
    "data-placement": e.placement
  };
  return e.referenceHidden && (t["data-reference-hidden"] = ""), e.escaped && (t["data-escaped"] = ""), t;
}
function $n(e, t) {
  if (e === t)
    return !0;
  if (typeof e == "object" && e != null && typeof t == "object" && t != null) {
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (var n in e)
      if (t.hasOwnProperty(n)) {
        if (!$n(e[n], t[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function Bi(e) {
  var t = [];
  return e.forEach(function(n) {
    t.find(function(r) {
      return $n(n, r);
    }) || t.push(n);
  }), t;
}
function qi(e, t) {
  var n, r;
  return Object.assign({}, t, {
    popperOptions: Object.assign({}, e.popperOptions, t.popperOptions, {
      modifiers: Bi([].concat(((n = e.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = t.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var At = Mn ? react.useLayoutEffect : react.useEffect;
function Mi(e) {
  var t = (0,react.useRef)();
  return t.current || (t.current = typeof e == "function" ? e() : e), t.current;
}
function vn(e, t, n) {
  n.split(/\s+/).forEach(function(r) {
    r && e.classList[t](r);
  });
}
var $i = {
  name: "className",
  defaultValue: "",
  fn: function(t) {
    var n = t.popper.firstElementChild, r = function() {
      var u;
      return !!((u = t.props.render) != null && u.$$tippy);
    };
    function i() {
      if (t.props.className && !r()) {
         false && 0;
        return;
      }
      vn(n, "add", t.props.className);
    }
    function o() {
      r() && vn(n, "remove", t.props.className);
    }
    return {
      onCreate: i,
      onBeforeUpdate: o,
      onAfterUpdate: i
    };
  }
};
function Ii(e) {
  function t(n) {
    var r = n.children, i = n.content, o = n.visible, s = n.singleton, u = n.render, c = n.reference, f = n.disabled, p = f === void 0 ? !1 : f, v = n.ignoreAttributes, b = v === void 0 ? !0 : v;
    n.__source, n.__self;
    var g = qn(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), O = o !== void 0, y = s !== void 0, E = (0,react.useState)(!1), A = E[0], R = E[1], j = (0,react.useState)({}), a = j[0], k = j[1], h = (0,react.useState)(), z = h[0], B = h[1], C = Mi(function() {
      return {
        container: dn(),
        renders: 1
      };
    }), S = Object.assign({
      ignoreAttributes: b
    }, g, {
      content: C.container
    });
    O && ( false && 0, S.trigger = "manual", S.hideOnClick = !1), y && (p = !0);
    var T = S, L = S.plugins || [];
    u && (T = Object.assign({}, S, {
      plugins: y && s.data != null ? [].concat(L, [{
        fn: function() {
          return {
            onTrigger: function(I, $) {
              var M = s.data.children.find(function(H) {
                var W = H.instance;
                return W.reference === $.currentTarget;
              });
              I.state.$$activeSingletonInstance = M.instance, B(M.content);
            }
          };
        }
      }]) : L,
      render: function() {
        return {
          popper: C.container
        };
      }
    }));
    var D = [c].concat(r ? [r.type] : []);
    return At(function() {
      var N = c;
      c && c.hasOwnProperty("current") && (N = c.current);
      var x = e(N || C.ref || dn(), Object.assign({}, T, {
        plugins: [$i].concat(S.plugins || [])
      }));
      return C.instance = x, p && x.disable(), o && x.show(), y && s.hook({
        instance: x,
        content: i,
        props: T,
        setSingletonContent: B
      }), R(!0), function() {
        x.destroy(), s?.cleanup(x);
      };
    }, D), At(function() {
      var N;
      if (C.renders === 1) {
        C.renders++;
        return;
      }
      var x = C.instance;
      x.setProps(qi(x.props, T)), (N = x.popperInstance) == null || N.forceUpdate(), p ? x.disable() : x.enable(), O && (o ? x.show() : x.hide()), y && s.hook({
        instance: x,
        content: i,
        props: T,
        setSingletonContent: B
      });
    }), At(function() {
      var N;
      if (u) {
        var x = C.instance;
        x.setProps({
          popperOptions: Object.assign({}, x.props.popperOptions, {
            modifiers: [].concat((((N = x.props.popperOptions) == null ? void 0 : N.modifiers) || []).filter(function(I) {
              var $ = I.name;
              return $ !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function($) {
                var M, H = $.state, W = (M = H.modifiersData) == null ? void 0 : M.hide;
                (a.placement !== H.placement || a.referenceHidden !== W?.isReferenceHidden || a.escaped !== W?.hasPopperEscaped) && k({
                  placement: H.placement,
                  referenceHidden: W?.isReferenceHidden,
                  escaped: W?.hasPopperEscaped
                }), H.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [a.placement, a.referenceHidden, a.escaped].concat(D)), /* @__PURE__ */ react.createElement(react.Fragment, null, r ? /* @__PURE__ */ (0,react.cloneElement)(r, {
      ref: function(x) {
        C.ref = x, zt(r.ref, x);
      }
    }) : null, A && /* @__PURE__ */ (0,react_dom.createPortal)(u ? u(ji(a), z, C.instance) : i, C.container));
  }
  return t;
}
var Wi = function(e, t) {
  return /* @__PURE__ */ (0,react.forwardRef)(function(r, i) {
    var o = r.children, s = qn(r, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ react.createElement(e, Object.assign({}, t, s), o ? /* @__PURE__ */ (0,react.cloneElement)(o, {
        ref: function(c) {
          zt(i, c), zt(o.ref, c);
        }
      }) : null)
    );
  });
}, Hi = /* @__PURE__ */ Wi(/* @__PURE__ */ Ii(Ze));
const In = Hi, Vi = "quiz", Fi = "quiz__container", Ui = "quiz__question", Yi = "mobile", Qi = "tablet", Xi = "desktop", Gi = "quiz__options", Ki = "tippy-box", Ji = "tippy-content", Zi = "quiz__nav", eo = "quiz__rectangles", to = "quiz__rectangle", no = "quiz__filled-rectangle", ro = "quiz__tooltip", io = "quiz__result-container", oo = "quiz__share_result-container", ao = "quiz__result-box", so = "quiz__results_text-box", co = "quiz__results_text", uo = "quiz__icon_section", lo = "quiz__results_share-box", po = "quiz__results_share-link", fo = "quiz__result-share-link-text", vo = "quiz__links-container", ho = "quiz__links-container-link", mo = "quiz__links-text", go = "quiz__links-share", q = {
  quiz: Vi,
  quizContainer: Fi,
  quizQuestion: Ui,
  mobile: Yi,
  tablet: Qi,
  desktop: Xi,
  quizOptions: Gi,
  tippyBox: Ki,
  tippyContent: Ji,
  quizNav: Zi,
  quizRectangles: eo,
  quizRectangle: to,
  quizFilledRectangle: no,
  quizTooltip: ro,
  quizResultContainer: io,
  quizShareResultContainer: oo,
  quizResultBox: ao,
  quizResultsTextBox: so,
  quizResultsText: co,
  quizIconSection: uo,
  quizResultsShareBox: lo,
  quizResultsShareLink: po,
  quizResultShareLinkText: fo,
  quizLinksContainer: vo,
  quizLinksContainerLink: ho,
  quizLinksText: mo,
  quizLinksShare: go
}, yo = "shareText", bo = "tippy--modal", wo = "tippy--modal--shareButton", Oo = "tippy--modal--shareIcon", Eo = "share-mobile-wrap", xo = "share-desktop-wrap", V = {
  shareText: yo,
  tippyModal: bo,
  tippyModalShareButton: wo,
  tippyModalShareIcon: Oo,
  shareMobileWrap: Eo,
  shareDesktopWrap: xo
}, So = (0,react.forwardRef)(
  function(t, n) {
    const { text: r = "Share", onClick: i } = t;
    return /* @__PURE__ */ react.createElement(
      Button_eec2778c.B.Secondary,
      {
        onClick: i,
        ref: n,
        type: "button",
        text: r,
        icon: Icon_e01b6482.W.ARROW_UP_RIGHT
      }
    );
  }
), Wn = So;
function To({
  url: e,
  text: t,
  onShareClick: n
}) {
  const r = async () => {
    const i = {
      url: `https://${e}`
    };
    e && (await navigator.share(i), n("mobile", e));
  };
  return /* @__PURE__ */ react.createElement(
    Wn,
    {
      text: t || "Share",
      onClick: r
    }
  );
}
var Pt = globalThis && globalThis.__assign || function() {
  return Pt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Pt.apply(this, arguments);
}, ko = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function bt(e) {
  var t = function(n) {
    var r = n.bgStyle, i = n.borderRadius, o = n.iconFillColor, s = n.round, u = n.size, c = ko(n, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return react.createElement(
      "svg",
      Pt({ viewBox: "0 0 64 64", width: u, height: u }, c),
      s ? react.createElement("circle", { cx: "32", cy: "32", r: "31", fill: e.color, style: r }) : react.createElement("rect", { width: "64", height: "64", rx: i, ry: i, fill: e.color, style: r }),
      react.createElement("path", { d: e.path, fill: o })
    );
  };
  return t.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, t;
}
function wt(e) {
  var t = Object.entries(e).filter(function(n) {
    var r = n[1];
    return r != null;
  }).map(function(n) {
    var r = n[0], i = n[1];
    return "".concat(encodeURIComponent(r), "=").concat(encodeURIComponent(String(i)));
  });
  return t.length > 0 ? "?".concat(t.join("&")) : "";
}
var Hn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var s = typeof o;
          if (s === "string" || s === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var u = n.apply(null, o);
              u && r.push(u);
            }
          } else if (s === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var c in o)
              t.call(o, c) && o[c] && r.push(c);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Hn);
var Co = Hn.exports;
const Ao = /* @__PURE__ */ nr(Co);
var Do = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), le = globalThis && globalThis.__assign || function() {
  return le = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, le.apply(this, arguments);
}, _o = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function u(p) {
      try {
        f(r.next(p));
      } catch (v) {
        s(v);
      }
    }
    function c(p) {
      try {
        f(r.throw(p));
      } catch (v) {
        s(v);
      }
    }
    function f(p) {
      p.done ? o(p.value) : i(p.value).then(u, c);
    }
    f((r = r.apply(e, t || [])).next());
  });
}, No = globalThis && globalThis.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s;
  return s = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function u(f) {
    return function(p) {
      return c([f, p]);
    };
  }
  function c(f) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = f[0] & 2 ? i.return : f[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, f[1])).done)
          return o;
        switch (i = 0, o && (f = [f[0] & 2, o.value]), f[0]) {
          case 0:
          case 1:
            o = f;
            break;
          case 4:
            return n.label++, { value: f[1], done: !1 };
          case 5:
            n.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              n = 0;
              continue;
            }
            if (f[0] === 3 && (!o || f[1] > o[0] && f[1] < o[3])) {
              n.label = f[1];
              break;
            }
            if (f[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = f;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(f);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        f = t.call(e, n);
      } catch (p) {
        f = [6, p], i = 0;
      } finally {
        r = o = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, Vn = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}, Ro = function(e) {
  return !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function";
}, Lo = function(e, t) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - t / 2
  };
}, zo = function(e, t) {
  return {
    top: (window.screen.height - t) / 2,
    left: (window.screen.width - e) / 2
  };
};
function Po(e, t, n) {
  var r = t.height, i = t.width, o = Vn(t, ["height", "width"]), s = le({ height: r, width: i, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, o), u = window.open(e, "", Object.keys(s).map(function(f) {
    return "".concat(f, "=").concat(s[f]);
  }).join(", "));
  if (n)
    var c = window.setInterval(function() {
      try {
        (u === null || u.closed) && (window.clearInterval(c), n(u));
      } catch (f) {
        console.error(f);
      }
    }, 1e3);
  return u;
}
var jo = (
  /** @class */
  function(e) {
    Do(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.openShareDialog = function(r) {
        var i = n.props, o = i.onShareWindowClose, s = i.windowHeight, u = s === void 0 ? 400 : s, c = i.windowPosition, f = c === void 0 ? "windowCenter" : c, p = i.windowWidth, v = p === void 0 ? 550 : p, b = le({ height: u, width: v }, f === "windowCenter" ? Lo(v, u) : zo(v, u));
        Po(r, b, o);
      }, n.handleClick = function(r) {
        return _o(n, void 0, void 0, function() {
          var i, o, s, u, c, f, p, v, b, g;
          return No(this, function(O) {
            switch (O.label) {
              case 0:
                return i = this.props, o = i.beforeOnClick, s = i.disabled, u = i.networkLink, c = i.onClick, f = i.url, p = i.openShareDialogOnClick, v = i.opts, b = u(f, v), s ? [
                  2
                  /*return*/
                ] : (r.preventDefault(), o ? (g = o(), Ro(g) ? [4, g] : [3, 2]) : [3, 2]);
              case 1:
                O.sent(), O.label = 2;
              case 2:
                return p && this.openShareDialog(b), c && c(r, b), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props;
      n.beforeOnClick;
      var r = n.children, i = n.className, o = n.disabled, s = n.disabledStyle, u = n.forwardedRef;
      n.networkLink;
      var c = n.networkName;
      n.onShareWindowClose, n.openShareDialogOnClick, n.opts;
      var f = n.resetButtonStyle, p = n.style;
      n.url, n.windowHeight, n.windowPosition, n.windowWidth;
      var v = Vn(n, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), b = Ao("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!o,
        disabled: !!o
      }, i), g = le(le(f ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, p), o && s);
      return react.createElement("button", le({}, v, { "aria-label": v["aria-label"] || c, className: b, onClick: this.handleClick, ref: u, style: g }), r);
    }, t.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, t;
  }(react.Component)
);
const Bo = jo;
var gt = globalThis && globalThis.__assign || function() {
  return gt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, gt.apply(this, arguments);
};
function Ot(e, t, n, r) {
  function i(o, s) {
    var u = n(o), c = gt({}, o), f = Object.keys(u);
    return f.forEach(function(p) {
      delete c[p];
    }), react.createElement(Bo, gt({}, r, c, { forwardedRef: s, networkName: e, networkLink: t, opts: n(o) }));
  }
  return i.displayName = "ShareButton-".concat(e), (0,react.forwardRef)(i);
}
var qo = bt({
  color: "#3b5998",
  networkName: "facebook",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
});
const Mo = qo;
var $o = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Io = (
  /** @class */
  function(e) {
    $o(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.name = "AssertionError", r;
    }
    return t;
  }(Error)
);
function Re(e, t) {
  if (!e)
    throw new Io(t);
}
function Wo(e, t) {
  var n = t.quote, r = t.hashtag;
  return Re(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + wt({
    u: e,
    quote: n,
    hashtag: r
  });
}
var Ho = Ot("facebook", Wo, function(e) {
  return {
    quote: e.quote,
    hashtag: e.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
const Vo = Ho;
var Fo = bt({
  color: "#007fb1",
  networkName: "linkedin",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
const Uo = Fo;
function Yo(e, t) {
  var n = t.title, r = t.summary, i = t.source;
  return Re(e, "linkedin.url"), "https://linkedin.com/shareArticle" + wt({ url: e, mini: "true", title: n, summary: r, source: i });
}
var Qo = Ot("linkedin", Yo, function(e) {
  var t = e.title, n = e.summary, r = e.source;
  return { title: t, summary: n, source: r };
}, {
  windowWidth: 750,
  windowHeight: 600
});
const Xo = Qo;
var Go = bt({
  color: "#00aced",
  networkName: "twitter",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
const Ko = Go;
function Jo(e, t) {
  var n = t.title, r = t.via, i = t.hashtags, o = i === void 0 ? [] : i, s = t.related, u = s === void 0 ? [] : s;
  return Re(e, "twitter.url"), Re(Array.isArray(o), "twitter.hashtags is not an array"), Re(Array.isArray(u), "twitter.related is not an array"), "https://twitter.com/share" + wt({
    url: e,
    text: n,
    via: r,
    hashtags: o.length > 0 ? o.join(",") : void 0,
    related: u.length > 0 ? u.join(",") : void 0
  });
}
var Zo = Ot("twitter", Jo, function(e) {
  return {
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
const ea = Zo;
var ta = bt({
  color: "#25D366",
  networkName: "whatsapp",
  path: "m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
});
const na = ta;
function ra() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function ia(e, t) {
  var n = t.title, r = t.separator;
  return Re(e, "whatsapp.url"), "https://" + (ra() ? "api" : "web") + ".whatsapp.com/send" + wt({
    text: n ? n + r + e : e
  });
}
var oa = Ot("whatsapp", ia, function(e) {
  return {
    title: e.title,
    separator: e.separator || " "
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
const aa = oa;
function sa({
  url: e,
  shareText: t,
  onShareClick: n
}) {
  return /* @__PURE__ */ react.createElement(
    ea,
    {
      url: e,
      className: V.tippyModalShareButton,
      onClick: () => n("Twitter", e)
    },
    /* @__PURE__ */ react.createElement(
      Ko,
      {
        iconFillColor: "black",
        size: 32,
        bgStyle: { fill: "none" },
        className: V.tippyModalShareIcon
      }
    ),
    /* @__PURE__ */ react.createElement("span", { className: V.shareText }, t?.shareOnTwitter || "Share on Twitter")
  );
}
function ca({
  url: e,
  onShareClick: t,
  shareText: n
}) {
  return /* @__PURE__ */ react.createElement(
    Xo,
    {
      url: e,
      className: V.tippyModalShareButton,
      onClick: () => t("LinkedIn", e)
    },
    /* @__PURE__ */ react.createElement(
      Uo,
      {
        iconFillColor: "black",
        size: 32,
        bgStyle: { fill: "none" },
        className: V.tippyModalShareIcon
      }
    ),
    /* @__PURE__ */ react.createElement("span", { className: V.shareText }, n?.shareOnLinkedIn || "Share on LinkedIn")
  );
}
function ua({
  url: e,
  onShareClick: t,
  shareText: n
}) {
  return /* @__PURE__ */ react.createElement(
    Vo,
    {
      url: e,
      className: V.tippyModalShareButton,
      onClick: () => t("Facebook", e)
    },
    /* @__PURE__ */ react.createElement(
      Mo,
      {
        iconFillColor: "black",
        size: 32,
        bgStyle: { fill: "none" },
        className: V.tippyModalShareIcon
      }
    ),
    /* @__PURE__ */ react.createElement("span", { className: V.shareText }, n?.shareOnFB || "Share on Facebook")
  );
}
function la({
  url: e,
  shareText: t,
  onShareClick: n
}) {
  return /* @__PURE__ */ react.createElement(
    aa,
    {
      url: e,
      className: V.tippyModalShareButton,
      onClick: () => n("WhatsApp", e)
    },
    /* @__PURE__ */ react.createElement(
      na,
      {
        iconFillColor: "black",
        size: 32,
        bgStyle: { fill: "none" },
        className: V.tippyModalShareIcon
      }
    ),
    /* @__PURE__ */ react.createElement("span", { className: V.shareText }, t?.shareOnWhatsApp || "Share on WhatsApp")
  );
}
const pa = ({
  url: e = "",
  shareText: t,
  onShareClick: n
}) => {
  const r = {
    url: e,
    onShareClick: n,
    shareText: t
  };
  return /* @__PURE__ */ react.createElement("ul", null, /* @__PURE__ */ react.createElement("li", { className: "list" }, /* @__PURE__ */ react.createElement(sa, { ...r })), /* @__PURE__ */ react.createElement("li", { className: "list" }, /* @__PURE__ */ react.createElement(ca, { ...r })), /* @__PURE__ */ react.createElement("li", { className: "list" }, /* @__PURE__ */ react.createElement(ua, { ...r })), /* @__PURE__ */ react.createElement("li", { className: "list" }, /* @__PURE__ */ react.createElement(la, { ...r })));
}, fa = ({
  url: e,
  text: t = "Share",
  locale: n = "en",
  shareText: r,
  onShareClick: i
}) => {
  const o = /* @__PURE__ */ react.createElement("div", { className: V.tippyModal }, /* @__PURE__ */ react.createElement(
    pa,
    {
      url: e,
      locale: n,
      shareText: r,
      onShareClick: i
    }
  ));
  return /* @__PURE__ */ react.createElement("div", { className: V.tippy }, /* @__PURE__ */ react.createElement(
    In,
    {
      trigger: "click",
      interactive: !0,
      content: o,
      placement: "top-start",
      appendTo: () => document.body,
      maxWidth: "none"
    },
    /* @__PURE__ */ react.createElement(Wn, { text: t })
  ));
}, da = fa;
function va(e) {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: V.shareMobileWrap }, /* @__PURE__ */ react.createElement(To, { ...e })), /* @__PURE__ */ react.createElement("div", { className: V.shareDesktopWrap }, /* @__PURE__ */ react.createElement(da, { ...e })));
}
function ha({
  userScore: e,
  ratingsArr: t,
  shareDescriptionText: n,
  shareLink: r,
  linkOneText: i,
  linkTwoText: o,
  linkOneButtonText: s,
  linkTwoButtonText: u,
  linkOnePrimaryLink: c,
  linkTwoPrimaryLink: f
}) {
  const [p, v] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    v(window.location.host);
  }, []);
  const b = t[e]?.ratingImage;
  return /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, null, /* @__PURE__ */ react.createElement(
    useClickOutside_55c64a80.B.Content,
    {
      className: q.quizResultContainer,
      style: {
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      }
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: q.quizShareResultContainer,
        style: {
          backgroundImage: b ? `url("${b}")` : void 0,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }
      },
      /* @__PURE__ */ react.createElement("div", { className: q.quizResultBox }, /* @__PURE__ */ react.createElement("b", null, e, "/5")),
      /* @__PURE__ */ react.createElement("div", { className: (0,useKeyDown_88662051.c)(q.quizQuestion, q.quizResultsTextBox) }, /* @__PURE__ */ react.createElement("div", { className: q.quizResultsText }, /* @__PURE__ */ react.createElement("b", null, t[e]?.ratingText)), /* @__PURE__ */ react.createElement("div", { className: q.quizIconSection }, /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.THUMBSUP, size: 42 }))),
      /* @__PURE__ */ react.createElement("div", { className: (0,useKeyDown_88662051.c)(q.quizResultsShareBox) }, /* @__PURE__ */ react.createElement(
        va,
        {
          url: p ? `${p}/${r}` : "",
          onShareClick: () => {
          }
        }
      ), /* @__PURE__ */ react.createElement("div", { className: q.quizResultShareLinkText }, n))
    ),
    /* @__PURE__ */ react.createElement("div", { className: q.quizLinksContainer }, /* @__PURE__ */ react.createElement("div", { className: q.quizLinksContainerLink }, /* @__PURE__ */ react.createElement("div", { className: q.quizLinksText }, i), /* @__PURE__ */ react.createElement(
      Link_460da2fc.L,
      {
        className: q.quizLinksShare,
        href: c,
        disableLinkTextStyle: !0,
        itemProp: "url",
        target: "_blank"
      },
      /* @__PURE__ */ react.createElement(
        Button_eec2778c.B.Primary,
        {
          text: s,
          icon: Icon_e01b6482.W.ARROW_UP_RIGHT,
          asDiv: !0
        }
      )
    )), /* @__PURE__ */ react.createElement("div", { className: q.quizLinksContainerLink }, /* @__PURE__ */ react.createElement("div", { className: q.quizLinksText }, o), /* @__PURE__ */ react.createElement(
      Link_460da2fc.L,
      {
        className: q.quizLinksShare,
        href: f,
        disableLinkTextStyle: !0,
        itemProp: "url",
        target: "_blank"
      },
      /* @__PURE__ */ react.createElement(
        Button_eec2778c.B.Primary,
        {
          text: u,
          icon: Icon_e01b6482.W.ARROW_UP_RIGHT,
          asDiv: !0
        }
      )
    )))
  ));
}
function Ta({
  backgroundImage: e,
  questions: t,
  ratingsArr: n,
  shareLink: r,
  shareDescriptionText: i,
  linkOneText: o,
  linkTwoText: s,
  linkOneButtonText: u,
  linkTwoButtonText: c,
  linkOnePrimaryLink: f,
  linkTwoPrimaryLink: p
}) {
  const [v, b] = (0,react.useState)(0), [g, O] = (0,react.useState)(0), [y, E] = (0,react.useState)(null), [A, R] = (0,react.useState)(Array(t.length).fill("")), [j, a] = (0,react.useState)(!1), k = (S) => {
    const T = [...A];
    T[v] = S, R(T);
    const L = T.filter(
      (D, N) => D === t[N].correctAnswer
    ).length;
    O(L), E(S);
  }, h = () => {
    v < t.length - 1 ? (b(v + 1), E(null)) : a(!0);
  }, z = () => t.map((S, T) => /* @__PURE__ */ react.createElement(
    "div",
    {
      key: T,
      className: (0,useKeyDown_88662051.c)(q.quizRectangle, {
        [q.quizFilledRectangle]: T === v
      })
    }
  )), B = () => {
    const S = t[v].correctAnswer;
    return t[v].options.map(
      (T, L) => {
        const D = T === S, N = y ? D ? Icon_e01b6482.W.CHECK : Icon_e01b6482.W.CLOSE : void 0, x = y !== null && D;
        return /* @__PURE__ */ react.createElement(
          In,
          {
            content: x ? t[v].tooltipText : "",
            key: L,
            placement: "top",
            visible: x,
            interactive: !0,
            className: q.quizTooltip
          },
          /* @__PURE__ */ react.createElement(
            Button_eec2778c.B.Quiz,
            {
              text: T,
              label: `${String.fromCharCode(65 + L)}`,
              onClick: () => {
                k(T);
              },
              customClass: (0,useKeyDown_88662051.c)({
                button__quiz__correct: y && D,
                button__quiz__incorrect: y && !D
              }),
              icon: N
            }
          )
        );
      }
    );
  }, C = () => {
    v > 0 && (b(v - 1), E(null));
  };
  return j ? /* @__PURE__ */ react.createElement(
    ha,
    {
      userScore: g,
      ratingsArr: n,
      shareDescriptionText: i,
      shareLink: r,
      linkOneText: o,
      linkTwoText: s,
      linkOneButtonText: u,
      linkTwoButtonText: c,
      linkOnePrimaryLink: f,
      linkTwoPrimaryLink: p
    }
  ) : /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, { topPadding: useClickOutside_55c64a80.B.Padding.NONE, bottomPadding: useClickOutside_55c64a80.B.Padding.NONE }, /* @__PURE__ */ react.createElement(
    "div",
    {
      className: q.quiz,
      style: {
        backgroundImage: e ? `url("${e}")` : void 0,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      }
    },
    /* @__PURE__ */ react.createElement("div", { className: q.quizContainer }, /* @__PURE__ */ react.createElement("div", { className: q.quizRectangles }, z()), /* @__PURE__ */ react.createElement("h1", { className: q.quizQuestion }, t[v].question), /* @__PURE__ */ react.createElement("div", { className: q.quizOptions }, B()), /* @__PURE__ */ react.createElement("div", { className: q.quizNav }, /* @__PURE__ */ react.createElement(
      Button_eec2778c.B.Secondary,
      {
        text: "Previous",
        onClick: C,
        disabled: v === 0,
        icon: Icon_e01b6482.W.ARROW_LEFT,
        iconPosition: "left"
      }
    ), v === t.length - 1 ? /* @__PURE__ */ react.createElement(
      Button_eec2778c.B.Secondary,
      {
        text: "See the results",
        onClick: h,
        disabled: !y,
        icon: Icon_e01b6482.W.ARROW_RIGHT
      }
    ) : /* @__PURE__ */ react.createElement(
      Button_eec2778c.B.Secondary,
      {
        text: "Next",
        onClick: h,
        disabled: !y,
        icon: Icon_e01b6482.W.ARROW_RIGHT
      }
    )))
  ));
}

//# sourceMappingURL=Quiz.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Quiz/Quiz.tsx





var extractPropsFromArray = function(ValueObj, searchId, property) {
    return Object.keys(ValueObj).filter(function(key) {
        return key.includes(searchId);
    }).map(function(key) {
        return ValueObj[key][property] || "";
    });
};
var getQuestionsArr = function(ValueObj, searchId) {
    return Object.keys(ValueObj).filter(function(key) {
        return key.includes(searchId);
    }).map(function(key) {
        var ref, ref1, ref2, ref3;
        return {
            question: ((ref = ValueObj[key]) === null || ref === void 0 ? void 0 : ref.question) || "",
            options: extractPropsFromArray((ref1 = ValueObj[key]) === null || ref1 === void 0 ? void 0 : ref1.answers, "answers", "answer"),
            correctAnswer: ((ref2 = ValueObj[key]) === null || ref2 === void 0 ? void 0 : ref2.correctAnswer) || "",
            tooltipText: ((ref3 = ValueObj[key]) === null || ref3 === void 0 ? void 0 : ref3.popupText) || ""
        };
    });
};
var getRatingsArr = function(ValueObj, searchId) {
    return Object.keys(ValueObj).filter(function(key) {
        return key.includes(searchId);
    }).map(function(key) {
        var ref, ref1, ref2;
        return {
            rating: ((ref = ValueObj[key]) === null || ref === void 0 ? void 0 : ref.rating) || 0,
            ratingText: ((ref1 = ValueObj[key]) === null || ref1 === void 0 ? void 0 : ref1.ratingText) || "",
            ratingImage: (0,magnolia/* getAssetPath */.K3)((ref2 = ValueObj[key]) === null || ref2 === void 0 ? void 0 : ref2.ratingImage) || ""
        };
    });
};
function Quiz(param) {
    var backgroundImage = param.backgroundImage, questions = param.questions, ratings = param.ratings, shareDescriptionText = param.shareDescriptionText, shareLink = param.shareLink, linkOneText = param.linkOneText, linkTwoText = param.linkTwoText, linkOneButtonText = param.linkOneButtonText, linkTwoButtonText = param.linkTwoButtonText, linkOnePrimaryLink = param.linkOnePrimaryLink, linkTwoPrimaryLink = param.linkTwoPrimaryLink;
    var questionsArr = getQuestionsArr(questions, "questions");
    var imageData = (0,magnolia/* getAssetPath */.K3)(backgroundImage);
    var ratingsArr = getRatingsArr(ratings, "ratings");
    var locale = (0,router.useRouter)().locale;
    var formatLink = (0,magnolia/* formatPageLink */.Jd)(shareLink);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ta, {
            backgroundImage: imageData,
            questions: questionsArr,
            ratingsArr: ratingsArr,
            shareLink: "".concat(locale).concat(formatLink),
            shareDescriptionText: shareDescriptionText,
            linkOneText: linkOneText,
            linkTwoText: linkTwoText,
            linkOneButtonText: linkOneButtonText,
            linkTwoButtonText: linkTwoButtonText,
            linkOnePrimaryLink: linkOnePrimaryLink,
            linkTwoPrimaryLink: linkTwoPrimaryLink
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/Quiz/index.ts



/***/ })

}]);